export type SocketMessage = {
  type: string;
  topic: string;
  payload: any;
  retained: boolean;
};

type Severity = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' | 'critical';

export type SocketLog = { message: string; extra?: any; level?: Severity };

export type LogMessage = SocketLog & { type: string };

export type WorkerMessage = {
  type: string;
  payload: any;
};

export const WorkerMessageType = {
  ENCAP: 'encap',
  CONNECTION_STATUS: 'connectionStatus',
  LOG: 'log',
  MESSAGE_LATENCY: 'messageLatency',
};

/**
 * Connection status
 * https://github.com/mqttjs/MQTT.js?tab=readme-ov-file#events
 */
export const ConnectionStatus = {
  DISCONNECT: 'disconnect',
  CONNECT: 'connect',
  RECONNECT: 'reconnect',
  CLOSE: 'close',
  END: 'end',
} as const;

export type ConnectionStatusType = typeof ConnectionStatus[keyof typeof ConnectionStatus];

export type ConnectionStatusMessage = {
  type: typeof ConnectionStatus[keyof typeof ConnectionStatus];
};

export type LatencyMessage = { topic: string; latency: number };
